import React from 'react';
import Select from '../select';
import { ConfigContext } from '../config-provider';

var MultiSelectInput = function MultiSelectInput(props) {
  var customizePrefixCls = props.prefixCls,
      defaultValue = props.defaultValue,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? '请输入或点击进行选择' : _props$placeholder,
      options = props.options,
      style = props.style;

  var handleOnChange = function handleOnChange(e) {
    if (props.onChange) {
      props.onChange(e);
    }
  };

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('input-select', customizePrefixCls);
  return /*#__PURE__*/React.createElement(Select, {
    mode: "tags",
    style: style,
    allowClear: true,
    showArrow: false,
    showSearch: true,
    placeholder: placeholder,
    defaultValue: defaultValue,
    onChange: handleOnChange,
    className: "".concat(prefixCls, "-tags"),
    dropdownClassName: "".concat(prefixCls, "-tags")
  }, options);
};

export default MultiSelectInput;